import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import Theme from 'utils/Theme'

import { useAppDispatch, useAppSelector } from 'store'
import $order from 'store/order'

import App from 'components/App'

import styles from './AppointmentHeader.module.scss'

export type Props = {
  onClose: () => void
}

const AppointmentHeader: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const step = useAppSelector(({ $order }) => $order.step)
  const isRtl = useAppSelector(({ $app }) => $app.isRtl)

  const getTitle = () => {
    switch (step) {
      case 1:
        return t('Choose service')
      case 2:
        return t('Choose date')
      default:
        return ''
    }
  }

  const handleBack = () => {
    if (step === 1) {
      onClose()
    } else {
      dispatch($order.set.step(step - 1))
    }
  }

  return (
    <App.Flex column aCenter gap={6} className={styles.container}>
      <svg width="100%" height="206" viewBox="0 0 375 206" fill="none" className={styles.svg} xmlns="http://www.w3.org/2000/svg">
        <path fill={Theme.get().primary} fillOpacity="0.04" fillRule="evenodd" clipRule="evenodd" d="M260 1.17819C174.302 7.21519 89.306 22.5162 40.517 40.6892C-14.877 61.3222 -55.148 89.4622 -77.077 122.858C-83.968 133.352 -86 139.338 -86 149.144C-86 154.806 -85.468 157.334 -83.405 161.473C-76.116 176.1 -52.614 184.333 -25.922 181.609C7.442 178.205 42.761 166.455 132.5 128.904C181.017 108.602 193.678 104.458 222.097 99.5762C237.566 96.9192 272.187 95.8312 285.381 97.5872C304.407 100.118 322.333 106.453 326.898 112.257C329.639 115.742 329.553 116.763 326.25 119.881C321.659 124.215 314.353 125.732 293.5 126.681C271.636 127.677 257.182 129.616 241.519 133.654C209.921 141.801 192.099 154.662 192.022 169.371C191.97 179.412 199.737 191.089 212.551 200.233C218.648 204.584 226 207.123 226 204.878C226 204.304 223.165 201.811 219.699 199.338C212.307 194.063 206.976 188.43 205.107 183.918C202.85 178.468 204.392 174.107 210.864 167.635C220.752 157.747 239.221 150.548 267.5 145.559C277.103 143.865 286.092 143.277 312.5 142.616C330.65 142.162 348.425 141.297 352 140.692C369.725 137.696 380.47 132.344 384.589 124.459C386.405 120.983 386.404 112.341 384.587 108.828C378.785 97.6082 355.992 86.2842 327.018 80.2272C307.383 76.1232 297.415 75.3042 275.551 76.0012C247.803 76.8852 226.913 79.7162 200.492 86.1742C172.85 92.9302 157.357 99.0282 106.5 123.169C44.633 152.536 15.766 164.037 -9.033 169.202C-20.17 171.521 -37.596 171.613 -45 169.39C-53.385 166.873 -59.772 162.376 -62.033 157.396C-64.696 151.529 -64.481 148.178 -60.963 140.744C-48.17 113.699 23.676 78.3482 97.618 62.7132C140.731 53.5962 177.998 49.5602 237.506 47.5632C272.465 46.3892 332.292 47.4212 361.5 49.7012C417.396 54.0642 459.392 64.6252 478.332 79.0832C480.909 81.0502 483.47 82.6592 484.023 82.6592C485.895 82.6592 488.962 76.2172 490.684 68.6692C492.63 60.1382 492.918 43.6052 491.194 39.4312C488.89 33.8572 469.834 22.2672 453.064 16.2402C436.483 10.2812 412.024 5.26419 384 2.07319C363.995 -0.203806 287.469 -0.756806 260 1.17819Z" />
      </svg>

      <App.Flex row center className={styles.back} onClick={handleBack}>
        <App.Icon icon="chevron-left" primary rotate={isRtl} />
        <App.Text small highlight>{t('Back')}</App.Text>
      </App.Flex>

      <App.Text large bold center>{getTitle()}</App.Text>

      <App.Flex row aCenter jBetween width={180} className={styles.steps}>
        <App.Flex center className={cn(styles.circle, {[styles.current]: step === 1}, {[styles.past]: step > 1})}>
          <App.Text xs semiBold muted={step < 1} highlight={step === 1} white={step > 1}>1</App.Text>
        </App.Flex>

        <App.Flex center className={cn(styles.circle, {[styles.current]: step === 2}, {[styles.past]: step > 2})}>
          <App.Text xs semiBold muted={step < 2} highlight={step === 2} white={step > 2}>2</App.Text>
        </App.Flex>

        <App.Flex className={cn(styles.line, {[styles.active]: step > 1})} />
      </App.Flex>
    </App.Flex>
  )
}

export default AppointmentHeader